import {Point} from "./Point";
import {Vec2} from "./Vec2";

export class ControlPoint extends Point {
  /**
   * @abstract
   * @param {CanvasRenderingContext2D} ctx
   * @param {Vec2} screen
   * @return void
   */
  draw(ctx, screen) {
    throw new Error('Draw method is not implemented!');
  }
}
